module.exports = __webpack_public_path__ + "img/back-3.2e840498.png";